import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button'


import Navbar from "../../components/Navbar/Navbar";
import classes from './ProductDescription.module.css';

import Foot from "../../components/Foot/Foot";

import { useState } from "react";

import ProductType from "../../components/ProductType/ProductType";
import Featured from "../../components/Featured/Featured";
import ProductDescImages from '../../components/ProductDescImages/ProductDescImages';
import db from "../../data/firebase";
import Spinner from 'react-bootstrap/Spinner';
import TopNote from "../../components/TopNote/TopNote";

function ProductDescription(props){
    const [product, setProduct] = useState();
    const [price, setPrice] = useState();
    const [perfumes, setPerfumes]= useState();
    const [decant, setDecant] = useState();
    
    let perfumeList=[];
    let currentUrl= window.location.search;
    let urlParams = new URLSearchParams(currentUrl);
    const currentPerfume = urlParams.get('perfume');
   


    function checking(){
        let i=0;
        db.collection("perfumes").get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                
                let temp={
                    id: doc.id,
                    data: doc.data(),
                }
                perfumeList[i]=temp;
                i++;
                if(temp.id === currentPerfume){
                    setProduct(temp);
                    setDecant(temp.data.priceAndBottle[0].image)

                }
                
            });
            setPerfumes(perfumeList);
    
        });
    }
  

    function changePrice(newPrice, img){
       
        setPrice(newPrice);
        setDecant(img);
      
        console.log(price)
    }

    

    return(

        <div className={classes.container}>
            {perfumes? null: checking()}       
            <Navbar/>
        

            {product? <div className={classes.images}>
                        <ProductDescImages product={product}/>
                    </div>: <Spinner animation="border" /> }
            
         
        <div className={classes.box}>
        

            <div className={classes.description}>
                <div className={classes.about}>
                    {product? <h2 className={classes.stock}>{product.data.stock === "available" ? null : "(OUT OF STOCK)"}</h2> : null }
                    
                    <h3>{product? product.data.name: <Spinner animation="border" />}</h3>
                  
                    <h6>{product? product.data.desc: <Spinner animation="border" />}</h6>
                </div>
              



            </div>

            {/* price buttons */}
            <div className={classes.priceAndQuantity}>
                    {product? <img className={classes.decantImg} src={decant}/> : <Spinner animation="border" /> }
                    
                    <h2>{price} BDT</h2>
                    <p className={classes.deliv}><b>Delivery charge : 
                        <h6>- Inside Dhaka +60 BDT</h6> 
                        <h6>- Outside Dhaka +130 BDT</h6>
                        </b></p>

                    <div>
                        {product? product.data.priceAndBottle.map((eachSize)=>(
                            <Button className={classes.styled} onClick={()=>changePrice(eachSize.price, eachSize.image)} variant="outline-dark">{eachSize.bottle}ml</Button>
                        )): <Spinner animation="border" />}
                        
                        
                        
                    </div>
            </div>

            
            {/*  Notes */}
            {product ? <div className={classes.table}>
                
                <TopNote product={product}/>

            </div> : <Spinner animation="border" />}

             {/* product type  */}
             {product ? <div className={classes.table}>
                <ProductType product={product}/>
            

            </div> : <Spinner animation="border" />}

           
        </div>

        {/* <div className={classes.priceAndQuantity}>
                    <h2>{price} BDT</h2>

                    <div>
                        {product? product.data.priceAndBottle.map((eachSize)=>(
                            <Button className={classes.styled} onClick={()=>changePrice(eachSize.price)} variant="outline-dark">{eachSize.bottle}ml</Button>
                        )): <Spinner animation="border" />}
                        
                        
                    </div>
            </div> */}

        
        <div className={classes.featured}>
            <Featured  title="YOU MAY ALSO LIKE"/>

        </div>
        

        <Foot/>
        
       

       
      </div>
    )
}


export default ProductDescription;   